
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-cost",
      function () {
        return require("private-next-pages/real-cost.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-cost"])
      });
    }
  